import { Card, Col, Container, Row } from "react-bootstrap";
import * as React from 'react';
import img from '../assets/info-icon.png';
import Tooltip from '@mui/material/Tooltip';
import LocalResults from "../api/local_results";
import MapResults from "../api/map_results";
import CsvCombiner from "../api/csv_combiner";
import Pipl from "../api/pipl";
import FileStatus from "../api/file_status";
import Gst from "../api/gst";
import Hotel from "../api/email";
import Elasticsearch from "../api/elasticsearch";
import StartupIndia from "../api/startupindia";
import Mca from "../api/mca";
import Operia from "../api/Operia";
import Gst_scrapper_fast from "../api/gst_scrapper_fast";
import Linkedin_url_fast from "../api/linkedin_url_fast";
import McaFileFilter from "../api/mca_file_filter";
import JobsScraper from "../api/jobs_scraper";
import LinkedinEmail from "../api/linkedin_to_email";
import QCAutomation from "../api/qc_automation";
import SellersScraper from "../api/sellers_scraper";
import CompanyWebsite from "../api/company_website";
import SheetsCombiner from "../api/sheets_combiner";
import JobScraperBulk from "../api/job_scraper_bulk";
import YTScraper from "../api/yt_scraper";
import InstaScraper from "../api/insta_scraper";
import DnbScraper from "../api/dnb_scraper";
import RocketScraper from "../api/rocket_scraper";
import YourstoryScraper from "../api/yourstory_scraper";
import IIMJobsScraper from "../api/iimjobs_scraper";
import IndeedScraper from "../api/indeed_scraper";
import InstamartScraper from "../api/instamart_scraper";
import DNBCompanyScraper from "../api/dnb_company_scraper";
import PhoneNumberVerification from "../api/callerapi";
import ApolloEmail from "../api/apollo_email";
import CinPlcChecker from "../api/cin_plc_checker";

const Module = ({ title, subtitle, component, message, customClass }) => {

  return (
    <Card className="shadow" style={{ padding: "0.75rem", marginTop: "1rem" }}>
      <Card
        className="shadow p-3 rounded"
        style={{ padding: "0.5rem", marginTop: "0.25rem", height: "auto" }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <div className="w-100">
            <div className="d-flex justify-content-between w-100">
              <Card.Title>{title}</Card.Title>
              <Tooltip title={message} placement="right-start" arrow>
                <img src={img} width="20px" style={{ height: "20px" }} alt="Info Icon" 
                className={`info-icon ${customClass || ""}`}/>
              </Tooltip>
            </div>
            <Card.Subtitle>{subtitle}</Card.Subtitle>
          </div>
        </div>
        {component}
      </Card>
    </Card>
  );
};

const ModulesGrid = () => {
  return (
    <Container fluid>
      <Row>
        <Col>
          <Module
            title={"PIPL"}
            sub_title={
              "Upload file, choose email ID and column name and get results from PIPL"
            }
            component={<Pipl />}
            message="1) To extract Phone Numbers using Linkedins or Emails as input.2) Depending upon the quantity ample time is consumed, roughly for 300 output expect 3 hours to extract.3) This tool has to be used only one at a time, hence has to be confirmed with others before uploading the data. 4) Expect 40% output, this may fluctuate depending upon availbility.5) Always mention the file name as for which client you are working upon.6) This is the only to tool to extract Phone numbers using email id."
            customClass="disabled"
          />
        </Col>
        <Col>
          <Module
            title={"GST"}
            sub_title={
              "Upload file, choose column name and get gst, cin and company website"
            }
            component={<Gst />}
            message="1) To Extract the CIN Numbers & GST Numbers2) If the company is public limited or private limited we use it to get the cin numbers and the GST numbers.3) If the input is a Proprietor or Partnership firm then we get the GST numbers.4) Expect 85% output in the case of CIN Numbers and 70% in the case of GST numbers.5) Always mention the file name as for which client you are working upon. 6) The output time is around 1hr for 100 leads"
          />
        </Col>
        <Col>
          <Module
            title={"GST Scrapper Fast"}
            sub_title={""}
            component={<Gst_scrapper_fast />}
            message="1) To extract the GST numbers of companies.2) This tool is to get the output fast.3) This tool doesn't works to get the CIN Numbers.4) The output percentage is around 70%.5) The time for 100 leads is 5-10mins"
          />
        </Col>
        <Col>
          <Module
            title={"Linkedin URL Fast"}
            sub_title={
              "Upload file, choose column name and get gst, cin and company website"
            }
            component={<Linkedin_url_fast />}
            message="1) To get the Person Linkedin ID or Company Linkedin ID
            2) For Person Linkedin ID the input is Person Name with Designation and Company Name or the Input can be Person Name with Company Name
            3) For Company Linkedin ID the input is Company Name
            4) The output percentage is 90%
            5) The output time is 100 leads is 10mins"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Module
            title={"File download"}
            sub_title={"Enter file name to check status and download"}
            component={<FileStatus />}
          />
        </Col>
        <Col>
          <Module
            title={"CSV Combiner"}
            sub_title={"Upload files to combine and remove duplicates"}
            component={<CsvCombiner />}
          />
        </Col>
        <Col>
          <Module
            title={"Operia"}
            sub_title={"Upload CSV files and get results from Operia"}
            component={<Operia />}
            message="1) To extract the companies basic details
            2) Basic details like Company Website, Industry, Employee Count & HQ Location
            3) To extract the data we need Company Linkedins
            4) The file breaks multiple times so we have to upload again and again to get the output
            5) This is the only tool in our server which gives us all the basic details
            6) The output time is undefined because we upload the files multiple times to get proper output"
          />
        </Col>
        <Col>
          <Module
            title={"Elasticsearch"}
            sub_title={
              "Upload file, choose column name and get results from elasticsearch"
            }
            component={<Elasticsearch />}
            message="1) This tool is our database
            2) This tool is used to get the phone numbers, emails and address
            3) To get the Phones input is emails and we get the person name as well
            4) To get the Emails input is Phones and we the get the person name as well
            5) This tool is used if the imput is society name then the output is the person name, phone, email and address
            6) This tool works as a geolocator"

          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Module
            title={"Company Website"}
            sub_title={"Upload file and get website of a company"}
            component={<CompanyWebsite />}
            message="1) To extract the websites of the companies
            2) Output is 65%
            3) The time for 100 leads is 1 hrs
            4) Its better to put file in batches of 500 leads to get a better and faster output"
          />
        </Col>

        <Col>
          <Module title={"MCA"} sub_title={""} component={<Mca />} message="1) To extract the company details of Private limited or LLCs
  2) The output percentage is 90%
  3) The time consumed for 100 leads is 1hr
  4) For better & faster output put it in batches of 500 leads
  5) This tool gives you the basic information of the companies starting from the email id associated to the Director's Name"
          />
        </Col>
        <Col>
          <Module
            title={"Jobs Scraper"}
            sub_title={"Enter url and no of pages as input"}
            component={<JobsScraper />}
            message="1) To extract the Job Links
            2) It's the tool that gives us the job description
            3) The maximum leads that it can process is 1000
            4) The output time is more than 1hr"
            customClass="disabled"
          />
        </Col>
        <Col>
          <Module
            title={"Startup India"}
            sub_title={""}
            component={<StartupIndia />}
            message="1) To extract the Startup that are registered in Government website
            2) This tool can't be stopped when it starts processing"
            customClass="disabled"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Module
            title={"Local Result"}
            sub_title={"Enter query and location"}
            component={<LocalResults />}
          />
          <Module
            title={"Mca File Filter"}
            sub_title={"Enter date , Upload Companies and Pincode Input Files"}
            component={<McaFileFilter />}
          />
          <Module
              title={"Rocket Reach Scraper"}
              sub_title={"Scrapes all profiles from rocketreach for given list id"}
              component={<RocketScraper />}
              message="1) Scrapes all profiles from rocketreach for the given list.
            2) List ID is required to scrape the profiles.
            3) Cookies are required to scrape the profiles."
            />
          <Module
              title={"Yourstory Scraper"}
              sub_title={"Scrapes bulk companies from yourstory.com"}
              component={<YourstoryScraper />}
              message="1) Scrapes all companies from yourstory url.
            2) This is a general scraper."
            />
          <Module
              title={"DNB Company scraper"}
              sub_title={"Scrapes companies from DNB"}
              component={<DNBCompanyScraper />}
              message="1) Scrapes companies from DNB.
              2) Max page scraping capacity is 15-20 pages.
              3) Paste the home page url of the company listing."
          />
        </Col>
        <Col>
          <Module
            title={"Linkedin to Emails"}
            sub_title={
              "Upload csv with following titles linkedin_url and value_proposition"
            }
            component={<LinkedinEmail />}
          />
          <Module
            title={"Apollo Email Finder"}
            sub_title={
              "Upload Excel/CSV with 'Linkedin Url' column to get emails from Apollo API"
            }
            component={<ApolloEmail />}
            message="1) Upload Excel or CSV file with 'Linkedin Url' column 2) Maximum 500 LinkedIn URLs per file 3) Returns email addresses or 'Not Found' for each LinkedIn URL"
          />
          <Module
            title={"Emails and Phones"}
            sub_title={
              "Upload file, choose column name and get gst, cin and company website"
            }
            component={<Hotel />}
            message="1) To extract the Emails and Phone Numbers that are available on websites
            2) The output time is 2-3 hrs for 100 leads"
          />
          <Module
            title={"Dnb scraper"}
            sub_title={
              "Upload file, set row_offset and get website link, and address"
            }
            component={<DnbScraper />}
            customClass="disabled"
          />
          <Module
              title={"IIMJobs Scraper"}
              sub_title={"Scrapes bulk jobs from iimjobs.com"}
              component={<IIMJobsScraper />}
              message="1) Scrapesbulk jobs from iimjobs url.
            2) This is a general scraper."
            />
        </Col>
        <Col>
          <Module
            title={"Map Result"}
            sub_title={"Enter query, lat & long"}
            component={<MapResults />}
            message="1) This tool is used the extract the data that is available on Google maps
            2) It gives us output of Mobile number, address and websites
            3) We do not get emails from this tool
            4) This tool is to get the companies data
            5) The latitude and longitude is the primary factor to get the output"
          />
          <Module
            title={"Job Scraper Bulk"}
            sub_title={"Scrapes Job listings from Naukari, Simplyhired, Indeed"}
            component={<JobScraperBulk />}
            customClass="disabled"
          />
          <Module
            title={"Instagram scraper"}
            sub_title={"Scrapes Instagram user profiles, hashtags & posts"}
            component={<InstaScraper />}
            message="1) To extract the instagram id of the people for different use case
            2) To extract the instagram ID of the followers of posts by a certain Hashtag
            3) To extract the instagram ID of the likes of posts by post link
            4) We get the instagram ID and Instagram Names of the people"
            customClass="disabled"
          />
          <Module
            title={"Indeed scraper"}
            sub_title={"Scrapes jobs from Indeed"}
            component={<IndeedScraper />}
            message="1) Extract bulk indeed jobs from given page url
            2) Max page scraping capacity is 25"
            customClass="disabled"
          />
        </Col>
        <Col>
          <Col>
            <Module
              title={"QC Automation"}
              sub_title={"Upload Excel file  for QC Tests"}
              component={<QCAutomation />}
              message="1) This is the QC tool
              2) This works on the basis of the index we fill and the exclusion (if provided) is given properly
              3) We use the tool to increase the Quality of our deliveries as it checks all the errors that are there in the sheet and has different colour markings
              4) RED Means there is error BLUE means Duplicate and YELLOW means Excluded data"
            />
            <Module
              title={"Scrape Sellers"}
              sub_title={"scrape sellers info from amazon, flipkart, myntra"}
              component={<SellersScraper />}
              message="1) To extract the seller details
              2) This tool only works for Amazon.com
              3) This scrapes the data according to the product a seller has posted"
            />
            {/* <Module
              title={"Excel Sheets Combiner"}
              sub_title={"Combines rocketreach, sn and apollo data into single sheet"}
              component={<SheetsCombiner />}
              message="1) To combine multiple excel sheets
            2) Its important the headers should have the same templates"
            /> */}
            <Module
              title={"Youtube scraper"}
              sub_title={"Scrapes youtube channel data for given search term"}
              component={<YTScraper />}
              message="1) To extract the data of the people who upload video on Youtube
            2) The keywords are required to find the links of the videos"
            />
            <Module
              title={"Indiamart scraper"}
              sub_title={"Scrapes products from Indiamart"}
              component={<InstamartScraper />}
              message="1) Scrapes bulk products information from indiamart
              2) Max page scraping capacity is 100
              3) Use inspect to get the product page url with api key"
          />
          <Module
              title={"Phone Number Verification"}
              sub_title={"Scrapes and verifies phone numbers"}
              component={<PhoneNumberVerification />}
              message="1) Takes an input excel file with phone_no column.
            2) All phone numbers must be in +91xxxxxxxxxx format.
            3) Verifies the phone number and returns an output excel file"
            />
          <Module
              title={"CIN PLC Checker"}
              sub_title={"Identify companies converted from Private to Public using CINs"}
              component={<CinPlcChecker />}
              message="1) Upload Excel file with CINs starting from row 9.
            2) Identifies companies that converted from Private to Public.
            3) CINs with PLC type and incorporation year before current year are flagged.
            4) Results displayed in a table with summary counts."
            />
          </Col>
        </Col>
      </Row>
    </Container>
  );
};

export default ModulesGrid;
